module.exports = __webpack_public_path__ + "static/media/snp.4207e912.png";